import { useParams } from 'react-router-dom'
import { withTranslatedMeta, withRouter } from 'i18n/utils'
import { isEmptySelector } from 'basket/selectors'
import { lastBookingLinkSelector } from 'booking/selectors'
import AccountForm from 'dashboard-account/components/AccountForm'
import Button from '@components/Button'
import 'dashboard-account/components//AccountView.scss'

const AccountView = ({ basketIsEmpty, lastBookingLink, history }) => {
    const { returnBack } = useParams()
    const [updatedAccount, setUpdatedAccount] = React.useState(false)

    return (
        <div className="container account-container dashboard-inner-container">
            {(lastBookingLink || !basketIsEmpty || returnBack) && (
                <Button className="mb-4" btnStyle="link" iconLeft="arrow-left" onClick={() => history.goBack()}>
                    <T>dashboard.button.back-to-booking</T>
                </Button>
            )}
            <AccountForm updatedAccount={updatedAccount} setUpdatedAccount={setUpdatedAccount} />
            <Button className="mt-4" btnStyle="outline-error" iconLeft="trash" href="/dashboard/account/delete" inline>
                <T>dashboard.account.delete.btn</T>
            </Button>
            <hr />
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    basketIsEmpty: isEmptySelector,
    lastBookingLink: lastBookingLinkSelector,
})

export default compose(withTranslatedMeta('dashboard.menu.account'), withRouter, connect(mapStateToProps))(AccountView)
